import React from 'react';
import { connect } from 'react-redux';

// Actions
import {
    requestLoadSharedEvent,
    canceledLoadSharedEvent
} from '../../../../services/sharedEvent/actions';

interface Props {
    requestLoadSharedEvent: Function;
    canceledLoadSharedEvent: Function;
    eventUuid: number;
}

export class SharedEventRequest extends React.PureComponent<Props> {
    componentDidMount() {
        const { eventUuid } = this.props;
        this.props.requestLoadSharedEvent(eventUuid);
    }

    componentWillUnmount() {
        this.props.canceledLoadSharedEvent();
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    {
        requestLoadSharedEvent,
        canceledLoadSharedEvent
    }
)(SharedEventRequest);
